export default __webpack_public_path__ + "static/media/netlify.603ef81c.png";